module.exports = __webpack_public_path__ + "static/media/loop.5735d771.mp4";